import {Customer} from '../../interfaces/customers/customer';
import {LightEmployeeFactory} from '../employees/light-employee-factory';
import {SocialInsuranceFactory} from '../core/social-insurance-factory';
import {DoDoctor} from '../../interfaces/doctors/do-doctor';
import {DoDoctorFactory} from '../doctors/do-doctor-factory';
import {ReRelativeFactory} from '../relatives/re-relative-factory';
import {ReRelative} from '../../interfaces/relatives/re-relative';
import {CustomerActivity} from '../../interfaces/customers/customer-activity';
import {CustomerActivityFactory} from '../../interfaces/customers/customer-activity-factory';
import {CalcHelper} from '../../helpers/calc-helper';


export class CustomerFactory {

  /**
   *
   * @param customer
   */
  public static fromObject(customer: any): Customer {
    return new class implements Customer {
      address: string = customer.address;
      fullRoute: string = customer.full_route;
      customId: number = customer.custom_id;
      firstName: string =  customer.first_name;
      fullName: string = customer.full_name;
      id: number = customer.id;
      name: string = customer.name;
      lastName: string = customer.last_name;
      locality: string = customer.locality;
      postalCode: string = customer.postal_code;
      route: string = customer.route;
      serviceFacilityId: number = customer.service_facility_id;
      latitude: number = CalcHelper.parseCoordinate(customer.latitude);
      longitude: number = CalcHelper.parseCoordinate(customer.longitude);
      streetNumber: string = customer.street_number;
      dateOfBirth: string = customer.date_of_birth;
      phone1: string = customer.phone_1;
      phone2: string = customer.phone_2;
      phone3: string = customer.phone_3;
      serviceFacilityIds: number[] = customer.service_facility_ids ?? [];
      email: string = customer.email;
      keyWord: string = customer.key_word;
      comment: string = customer.comment;
      ssn: string = customer.ssn;
      age: number = customer.age;
      fullSsn: string = customer.full_ssn;
      socialInsurance = customer.social_insurance ? SocialInsuranceFactory.fromObject(customer.social_insurance) : null;
      primaryNurse = customer.primary_nurse ? LightEmployeeFactory.fromObject(customer.primary_nurse) : null;
      primaryAb = customer.primary_ab ? LightEmployeeFactory.fromObject(customer.primary_ab) : null;
      primaryHh = customer.primary_hh ? LightEmployeeFactory.fromObject(customer.primary_hh) : null;
      primaryPa = customer.primary_pa ? LightEmployeeFactory.fromObject(customer.primary_pa) : null;
      doDoctors: DoDoctor[] = customer.do_doctors ? DoDoctorFactory.fromArray(customer.do_doctors) : [];
      key: string = customer.key;
      reRelatives: ReRelative[] = customer.re_relatives ? ReRelativeFactory.fromArray(customer.re_relatives) : [];
      previousCustomerActivities: CustomerActivity[] =
        customer.previous_customer_activities ?
          CustomerActivityFactory.fromArray(customer.previous_customer_activities) : [];
      nextCustomerActivities: CustomerActivity[] =
        customer.next_customer_activities ?
          CustomerActivityFactory.fromArray(customer.next_customer_activities) : [];
      careLevel: number = customer.care_level;
      lastDataUpdate: string = null;
    };
  }

  /**
   *
   * @param customers
   */
  public static fromArray(customers: any[]): Customer[] {
    return customers.map(_customer => CustomerFactory.fromObject(_customer));
  }

}
